<template>
  <div class="sidebar-layout">
    <!-- Conteúdo da barra lateral -->
    <Sidebar>
      <template #sidebar-content>
        <slot name="sidebar" />
      </template>
    </Sidebar>

    <div class="content">
      <Breadcrumb :path="breadcrumb" :rootPath="rootPath" />

      <!-- Espaço para inserir o menu de hotéis ou algum conteúdo relevante
      quando necessário -->
      <slot name="gap-before-content" />

      <!-- Título SEPARADO -->
      <div
        v-if="pageTitle"
        class="separate-page-title"
        :class="{ 'has-page-description': this.$slots['page-description'] }"
      >
        <slot name="page-title">
          <h2 class="separate-page-title--page-title">{{ pageTitle }}</h2>
        </slot>

        <div
          class="separate-page-title--description"
          v-if="this.$slots['page-description']"
        >
          <slot name="page-description" />
        </div>
      </div>

      <!-- Espaço para inserir conteúdo depois do título -->
      <slot name="gap-after-title" />

      <!-- Conteúdo principal -->
      <div class="content--white_card">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Layout com o modelo de criação/edição do item selecionado
 * @see https://www.figma.com/file/JvXkgtkQi2HYE6Gn0sqvlz26/Hotels-Design-System?node-id=2860%3A3253
 * Ex: Tela de criação/edição de cupons
 */
import Breadcrumb from '@/components/_base/patterns/Breadcrumb'
import Sidebar from '@/components/_base/patterns/Sidebar'

export default {
  name: 'SidebarLayout3',
  components: {
    Breadcrumb,
    Sidebar
  },
  props: {
    /**
     * Caminho de pão
     */
    breadcrumb: {
      type: Array,
      default: () => [
        {
          label: 'Link 1',
          url: '/',
          isSpa: false /**  se é um link para o site novo ou antigo */
        },
        {
          label: 'Link 2',
          url: '/',
          isSpa: true /**  se é um link para o site novo ou antigo */
        }
      ]
    },
    /**
     * Link inicial do caminho de pão
     */
    rootPath: {
      type: Object,
      default: () => ({
        label: 'Home',
        url: '/',
        isSpa: true /** se é um link para o site novo ou antigo */
      })
    },
    pageTitle: {
      type: String,
      default: ''
    }
  },
  created() {
    /** Retorna URL salva no LocalStorage */
    const savedURL = localStorage.getItem('homePage')

    /** Define o URL como a página principal do usuário */
    if (savedURL !== null) {
      this.rootPath.url = savedURL
      this.rootPath.isSpa = false
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-layout {
  display: grid;
  grid-template-columns: 250px 1fr;
  grid-gap: 0 26px;
  min-height: calc(100vh - 50px);
  background-color: $gray-bg;

  & > .content {
    padding-top: 34px;
    padding-right: 26px;
  }
}

.separate-page-title {
  margin-top: 18px;
  padding-bottom: 10px;
  background-color: $white;
  @include drop-shadow();

  /**
  * Quando houver descrição: mantém o espacamento padrão reduzindo a altura ocupada pela descrição
  * Cálculo: Espaçamento padrão - (Font-size + margin)
  */
  &.has-page-description {
    padding-bottom: 0;
  }

  &--page-title {
    margin: 0;
    padding: 17px 50px;
    font-size: font-size('size-large');
    font-weight: font-weight('weight-light');
    line-height: 1.3;
    border-bottom: 1px solid $gray-border;
  }

  &--description {
    font-size: font-size('size-small');
    font-weight: font-size('weight-normal');
    margin-top: 5px;
  }
}

.content {
  text-align: left;
  margin-bottom: 40px;

  &--white_card {
    margin-top: 18px;
    background-color: $white;
    padding: {
      top: card-spacing('side-large');
      right: card-spacing('side-large');
      left: card-spacing('side-large');
      bottom: card-spacing('bottom-large');
    }
    @include drop-shadow();
  }
}
</style>
